/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Button } from "semantic-ui-react";
import Select from "react-select";
import {
  getProfissionaisExecutantes,
  getOcupacoes,
  getEstados,
  getConselhos,
  getIndicacoesAcidente,
  getTiposConsulta,
  postProfissionalExecutante,
} from "@store/actions/index";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import {
  selectFieldStyle,
  selectFieldStyleError,
  selectFieldStyleDisplayNone,
} from "@utils/const";
import _ from "lodash";
import "@styles/consulta-eletiva.css";
import m from "@utils/strings";
import { removeAccents } from "@utils/stringUtil";

class FormSolicitacao extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasSubmitted: false,
      nomeDoProfissionalSelecionado: "",

      ocupacoes: [],
      ocupacaoSelecionada: "",

      profissionalSelecionado: "",
      profissionaisExecutantesToRender: [], //com opção default
      profissionaisExecutantes: [],
      profissionaisExecutantesOcupacoes: [],

      tipoConsultaSelecionado: { value: "1", label: "Primeira Consulta" },
      indicacaoAcidenteSelecionado: { value: "9", label: "Não Acidente" },
      indicacoesAcidente: [],
      tiposConsulta: [],
      triedToSubmit: false,
    };

    this.handleValidateSolicitacaoFields =
      this.handleValidateSolicitacaoFields.bind(this);
    this.verifyIfSolicitacaoFieldsIsFilled =
      this.verifyIfSolicitacaoFieldsIsFilled.bind(this);
    this.handleSetInitialFieldsStateSolicitacao =
      this.handleSetInitialFieldsStateSolicitacao.bind(this);
  }

  componentDidMount() {
    this.loadInputDatas();
    this.props.validateSolicitacaoFields(this.handleValidateSolicitacaoFields);
    this.props.setInitialFieldsState(
      this.handleSetInitialFieldsStateSolicitacao
    );
    this.props.verifyIfSolicitacaoFieldsIsFilled(
      this.verifyIfSolicitacaoFieldsIsFilled
    );
  }

  loadInputDatas = () => {
    if (_.isEmpty(this.props.prestador)) {
      setTimeout(() => {
        this.loadInputDatas();
      }, 1000);
      return;
    }
    this.props.getProfissionaisExecutantes(
      this.props.prestador.Id,
      (result) => {
        console.log(result);
        let profissionaisInput = result.data.map((profissional) => {
          console.log(profissional);
          return profissional.ProfissionalExecutante;
        });
        let arrayUpdate = profissionaisInput.map((profissional) => {
          console.log(profissional);
          return {
            value: profissional,
            profissional: profissional,
            label: `${profissional.Nome} - ${profissional.Conselho}-${profissional.Estado} ${profissional.Numeroconselho}`,
          };
        });

        this.setState({ profissionaisExecutantesToRender: arrayUpdate });
        this.setState({ profissionaisExecutantes: profissionaisInput });
        this.setState({ profissionaisExecutantesOcupacoes: result.data });
      },
      (error) => {
        this.props.openSnackbar(
          m.TELA_CONSULTA_ELETIVA.NOTIFICACAO_ERRO_LISTAR_PROFISSIONAIS,
          "error"
        );
      }
    );
    this.props.getOcupacoes((result) => {
      let ocupacoesInput = result.data.map((ocupacao) => {
        return {
          descricao: ocupacao.Descricao,
          id: ocupacao.Id,
        };
      });
      this.setState({ ocupacoes: ocupacoesInput });
    });
    this.props.getIndicacoesAcidente((result) => {
      let indicacoesAcidente = result.data.map((indicacao) => {
        return {
          descricao: indicacao.Descricao,
          codigo: indicacao.Codigo,
        };
      });
      this.setState({ indicacoesAcidente });
    });
    this.props.getTiposConsulta((result) => {
      let tiposConsulta = result.data.map((tipoConsulta) => {
        return {
          descricao: tipoConsulta.Descricao,
          codigo: tipoConsulta.Codigo,
        };
      });
      this.setState({ tiposConsulta });
    });
  };

  indicacaoAcidenteSelect = (indicacaoAcidenteSelecionado) => {
    this.setState({ indicacaoAcidenteSelecionado });
  };

  tipoConsultaSelect = (tipoConsultaSelecionado) => {
    this.setState({ tipoConsultaSelecionado });
  };

  profissionalSolicitanteSelect = (event) => {
    this.setState({ profissionalSelecionado: event });

    let getOcupacaoDoProfissional;

    if (event.profissional)
      this.state.profissionaisExecutantesOcupacoes.forEach((profissional) => {
        if (event.profissional.nome == profissional.ProfissionalExecutante.Nome)
          getOcupacaoDoProfissional = profissional;
      });

    let ocupacoesDoProfissionalQueExistemEmBanco = [];

    if (getOcupacaoDoProfissional)
      this.state.ocupacoes.forEach((ocupacao) => {
        if (getOcupacaoDoProfissional.Ocupacoes.length == 1) {
          if (
            ocupacao.Descricao ==
            getOcupacaoDoProfissional.Ocupacoes[0].Descricao
          ) {
            let ocupacaoSelecionada = {
              value: ocupacao.descricao,
              label: `${ocupacao.id} - ${ocupacao.descricao}`,
            };
            setTimeout(() => {
              this.ocupacaoSelect(ocupacaoSelecionada);
            }, 100);
          }
        } else if (getOcupacaoDoProfissional.Ocupacoes.length > 1) {
          getOcupacaoDoProfissional.Ocupacoes.forEach(
            (ocupacaoProfissional) => {
              if (ocupacao.descricao == ocupacaoProfissional.descricao)
                ocupacoesDoProfissionalQueExistemEmBanco.push({
                  descricao: ocupacao.descricao,
                  id: ocupacao.id,
                });
            }
          );
        }
      });
    let reorderOcupacoes = [];
    ocupacoesDoProfissionalQueExistemEmBanco.forEach((ocupacao) => {
      reorderOcupacoes.push(ocupacao);
    });
    this.state.ocupacoes.forEach((ocupacao) => {
      let alreadyThere = false;
      reorderOcupacoes.forEach((ocupacaoDoProfissional) => {
        if (ocupacao.descricao == ocupacaoDoProfissional.descricao)
          alreadyThere = true;
      });
      if (!alreadyThere) reorderOcupacoes.push(ocupacao);
    });
    this.setState({ ocupacoes: reorderOcupacoes });
  };

  ocupacaoSelect = (event) => {
    this.setState({ ocupacaoSelecionada: event });
  };

  findIdOcupacao = (ocupacao = null) => {
    let returnVar = {};
    let ocupacaoSelecionada;
    if (ocupacao) ocupacaoSelecionada = ocupacao.value;
    else ocupacaoSelecionada = this.state.ocupacaoSelecionada.value;
    this.state.ocupacoes.forEach((ocupacao) => {
      if (ocupacao.descricao == ocupacaoSelecionada)
        returnVar = {
          codigo: ocupacao.codigo,
          descricao: ocupacao.descricao,
          id: ocupacao.id,
        };
    });
    return returnVar;
  };

  submitFormElegibilidade = () => {
    if (this.props.submitFormElegibilidade) {
      this.props.submitFormElegibilidade();
    }
  };

  handleSubmit = () => {
    this.setState({ hasSubmitted: true });

    if (
      !_.isEmpty(this.state.profissionalSelecionado) &&
      !_.isEmpty(this.state.ocupacaoSelecionada) &&
      !_.isEmpty(this.state.ocupacaoSelecionada.label) &&
      !_.isEmpty(this.state.indicacaoAcidenteSelecionado) &&
      !_.isEmpty(this.state.indicacaoAcidenteSelecionado.label) &&
      !_.isEmpty(this.state.tipoConsultaSelecionado) &&
      !_.isEmpty(this.state.tipoConsultaSelecionado.label)
    ) {
      let profissionalToUpdate =
        this.state.profissionalSelecionado.profissional;
      profissionalToUpdate.ocupacao = this.findIdOcupacao();
      this.props.updateDadosSolicitacao({
        profissionalExecutante: profissionalToUpdate,
      });

      this.props.autorizarConsultaEletiva({
        tipoConsulta: this.state.tipoConsultaSelecionado.value,
        indicacaoAcidente: this.state.indicacaoAcidenteSelecionado.value,
      });
    }
  };

  handleValidateSolicitacaoFields = (justDisableFields = false) => {
    if (!justDisableFields) {
      this.handleSubmit();
    } else {
      this.setState({ hasSubmitted: true });
    }
  };

  verifyIfSolicitacaoFieldsIsFilled = () => {
    this.setState({ triedToSubmit: true });
    if (
      _.isEmpty(this.state.profissionalSelecionado) ||
      _.isEmpty(this.state.ocupacaoSelecionada) ||
      _.isEmpty(this.state.indicacaoAcidenteSelecionado) ||
      _.isEmpty(this.state.tipoConsultaSelecionado)
    ) {
      return false;
    } else {
      this.setState({ triedToSubmit: false });
      return true;
    }
  };

  handleSetInitialFieldsStateSolicitacao = () => {
    this.setState({
      hasSubmitted: false,
      nomeDoProfissionalSelecionado: "",
      estadoSelecionado: "",

      ocupacoes: [],
      ocupacaoSelecionada: "",

      conselhoSelecionado: "",
      numeroConselhoSelecionado: "",

      profissionalSelecionado: "",
      profissionaisExecutantesToRender: [], //com opção default
      profissionaisExecutantes: [],
      profissionaisExecutantesOcupacoes: [],
      tipoConsultaSelecionado: { value: "1", label: "Primeira Consulta" },
      indicacaoAcidenteSelecionado: { value: "9", label: "Não Acidente" },
      indicacoesAcidente: [],
      tiposConsulta: [],
      triedToSubmit: false,
    });
    this.loadInputDatas();
  };

  render() {
    return (
      <div className={"form-solicitacao"}>
        <Form>
          <Form.Group>
            <Form.Field
              inline={true}
              width={10}
              disabled={this.state.hasSubmitted}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_CONSULTA_ELETIVA.LABEL_PROFISSIONAL_EXECUTANTE}
                </label>
              </div>
              <Select
                value={this.state.profissionalSelecionado}
                onChange={this.profissionalSolicitanteSelect}
                disabled={this.state.hasSubmitted}
                placeholder=""
                noOptionsMessage={({ inputString }) => {
                  return m.TELA_CONSULTA_ELETIVA
                    .MENSAGEM_NENHUM_PROFISSIONAL_ENCONTRADO;
                }}
                styles={
                  !_.isEmpty(this.state.profissionalSelecionado) ||
                  !this.state.triedToSubmit
                    ? selectFieldStyle
                    : selectFieldStyleError
                }
                onInputChange={this.onProfissionalInputChange}
                options={this.state.profissionaisExecutantesToRender}
                ref={(input) => {
                  this.textInput = input;
                }}
                filterOption={(field, value) => {
                  value = value.toUpperCase();
                  value = removeAccents(value);
                  field.label = field.label.toUpperCase();
                  field.label = removeAccents(field.label);
                  if (
                    field.label.includes(value) ||
                    (this.profissionalNaoEncontrado != null &&
                      field.label ===
                        this.profissionalNaoEncontrado.toUpperCase())
                  )
                    return true;
                  else return false;
                }}
              />
              <ErrorMsgLabel
                boolean={
                  _.isEmpty(this.state.profissionalSelecionado) &&
                  this.state.triedToSubmit
                }
                message={m.TELA_CONSULTA_ELETIVA.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={6}
              disabled={this.state.hasSubmitted}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_CONSULTA_ELETIVA.LABEL_OCUPACAO}
                </label>
              </div>
              <Select
                value={this.state.ocupacaoSelecionada}
                onChange={this.ocupacaoSelect}
                placeholder=""
                disabled={this.state.hasSubmitted}
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return m.TELA_CONSULTA_ELETIVA
                    .MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA;
                }}
                styles={
                  !_.isEmpty(this.state.ocupacaoSelecionada) ||
                  !this.state.triedToSubmit
                    ? selectFieldStyle
                    : selectFieldStyleError
                }
                options={this.state.ocupacoes.map((ocupacao) => {
                  return {
                    value: ocupacao.descricao,
                    label: `${ocupacao.id} - ${ocupacao.descricao}`,
                  };
                })}
              />
              <ErrorMsgLabel
                boolean={
                  _.isEmpty(this.state.ocupacaoSelecionada) &&
                  this.state.triedToSubmit
                }
                message={m.TELA_CONSULTA_ELETIVA.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field
              inline={true}
              width={5}
              disabled={this.state.hasSubmitted}
            >
              <div>
                <label className="field-label">
                  {m.TELA_CONSULTA_ELETIVA.LABEL_INDICACAO_ACIDENTE}
                </label>
              </div>
              <div>
                <Select
                  placeholder=""
                  value={this.state.indicacaoAcidenteSelecionado}
                  onChange={this.indicacaoAcidenteSelect}
                  disabled={this.state.hasSubmitted}
                  noOptionsMessage={({ inputValuetringrequired }) => {
                    return m.TELA_CONSULTA_ELETIVA.LABEL_INDICACAO_ACIDENTE;
                  }}
                  styles={
                    this.state.indicacaoAcidenteSelecionado &&
                    _.isEmpty(this.state.indicacaoAcidenteSelecionado.label) &&
                    this.state.triedToSubmit
                      ? selectFieldStyleError
                      : selectFieldStyle
                  }
                  options={this.state.indicacoesAcidente.map((indicacao) => {
                    return {
                      value: indicacao.codigo,
                      label: indicacao.descricao,
                    };
                  })}
                />
              </div>
              <ErrorMsgLabel
                boolean={
                  this.state.indicacaoAcidenteSelecionado &&
                  _.isEmpty(this.state.indicacaoAcidenteSelecionado.label) &&
                  this.state.triedToSubmit
                }
                message={m.TELA_CONSULTA_ELETIVA.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={5}
              disabled={this.state.hasSubmitted}
            >
              <div>
                <label className="field-label">
                  {m.TELA_CONSULTA_ELETIVA.LABEL_TIPO_CONSULTA}
                </label>
              </div>
              <div>
                <Select
                  placeholder=""
                  value={this.state.tipoConsultaSelecionado}
                  onChange={this.tipoConsultaSelect}
                  disabled={this.state.hasSubmitted}
                  noOptionsMessage={({ inputValuetringrequired }) => {
                    return m.TELA_CONSULTA_ELETIVA
                      .MENSAGEM_NENHUM_TIPO_CONSULTA_ENCONTRADO;
                  }}
                  styles={
                    this.state.tipoConsultaSelecionado &&
                    _.isEmpty(this.state.tipoConsultaSelecionado.label) &&
                    this.state.triedToSubmit
                      ? selectFieldStyleError
                      : selectFieldStyle
                  }
                  options={this.state.tiposConsulta.map((tipoConsulta) => {
                    return {
                      value: tipoConsulta.codigo,
                      label: tipoConsulta.descricao,
                    };
                  })}
                />
              </div>
              <ErrorMsgLabel
                boolean={
                  this.state.tipoConsultaSelecionado &&
                  _.isEmpty(this.state.tipoConsultaSelecionado.label) &&
                  this.state.triedToSubmit
                }
                message={m.TELA_CONSULTA_ELETIVA.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={false}
              width={6}
              disabled={this.state.hasSubmitted}
            >
              <Button
                id="btn-form-avancar"
                onClick={this.submitFormElegibilidade}
              >
                {m.TELA_CONSULTA_ELETIVA.LABEL_AUTORIZAR} (ENTER)
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    prestador: state.prestador,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProfissionaisExecutantes,
      getOcupacoes,
      getEstados,
      getConselhos,
      getIndicacoesAcidente,
      getTiposConsulta,
      postProfissionalExecutante,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FormSolicitacao);
